import createVueComponent from '../createVueComponent';

const Power = createVueComponent('PowerIcon', [
  ['path', { d: 'M18.36 6.64a9 9 0 1 1-12.73 0', key: 'phirl6' }],
  ['line', { x1: '12', x2: '12', y1: '2', y2: '12', key: 'aemgbe' }],
]);

export default Power;
